import type { BreakElement } from '../internal';
import { BreakVariant, createDefaultText } from '../internal';

export function createDefaultBreak(): BreakElement {
  return {
    children: [createDefaultText()],
    suggestedEdits: [],
    type: 'break',
    variant: BreakVariant.Page,
  };
}
